
import Vue from  'vue'

// import VueYouTubeEmbed from 'vue-youtube-embed'
// Vue.use(VueYouTubeEmbed)

// import CoreDragArea from '../core-drag-area'

// const TYPE_YOUTUBE = 'youtube'
// const TYPE_NATIVE = 'native'

// Vue.component('core-video-player', {

const mixin = {

    // template,
    // replace: false,

    data()
    {
        return {

            currentTimelineValue: 0,
            isPlaying: false,
            isMuted: false
        }
    },

    props: {

        src : { type: String, default: null },
        poster: { type: String, default: '' },
        // type: { type: String, default: [TYPE_NATIVE, TYPE_YOUTUBE][1] },

        nativeControls: { type: Boolean, default: false },

        // active: { type: Boolean, default: true},
        controls: { type: Boolean,  default: false },
        autoplay: { type: Boolean, default: true },
        // mute: { type: Boolean, default: false },
        loop: { type: Boolean, default: true },

        width: { type: Number, default: 640 },
        height: { type: Number, default: 360 }
    },

    /*watch: {

        currentTimelineValue: function() {
            this.$emit('time', currentTimelineValue, this.getTotalTime())
        },

        isPlaying: function() {
            this.$emit('play', currentTimelineValue, this.isPlaying)
        },

        isPlaying: function() {
            this.$emit('sound', currentTimelineValue, this.isMuted ? 0 : 1)
        }
    },*/

    created()
    {
        this._stopSeek = this._stopSeek.bind(this)

        /*this._duration      = 0
        this._currentTime   = 0
        this._timelineValue = 0

        this.paused = null;*/

        // this.eventHub.$on('update', this.update.bind(this));

        // hack Android delay for pause
        // cause bug to seekbar (multiples update timeline)
        this._timeUpdateEnable = true
    },

    mounted()
    {

        /*this.paused           = true;
        this.muted            = false;
        this.progressTimer    = null;
        this.isFirstPlay      = true;

        this.$player = this.$el.querySelector('.js-video');

        this.$player.addEventListener('loadedmetadata', this.onPlayerReady.bind(this), false);
        this.$player.addEventListener('play', this.onPlayerStateChange.bind(this), false);
        this.$player.addEventListener('pause', this.onPlayerStateChange.bind(this), false);
        this.$player.addEventListener('ended', this.onPlayerStateChange.bind(this), false);
        this.$player.addEventListener('progress', this.onPlayerStateChange.bind(this), false);
        this.$player.addEventListener('error', this.onPlayerError.bind(this), false);*/
    },

    methods: {

        /*
                ┌─────────────────────────────────────────────
                │
                │       YOUTUBE PIPE
                │
                └─────────────────────────────────────────────
        */


        _onYoutubeReady( player )
        {
            this._youtubePlayer = player
            // pausevideo
            // playVideo
            // playVideoAt
            // console.log('_onYoutubeReady', player)
            this.$emit('ready', this)
        },

        _onYoutubeEnded( player )
        {
            // console.log('_onYoutubeEnded', player)
            this._complete()
        },

        _onYoutubePlaying( player )
        {
            this._play()
            // console.log('_onYoutubePlaying', player)
        },

        _onYoutubePaused( player )
        {
            this._pause()
            // console.log('_onYoutubePaused', player)
        },

        _onYoutubeBuffering( player )
        {
            // console.log('_onYoutubeBuffering', player)
        },

        _onYoutubeQued( player )
        {
            // console.log('_onYoutubeQued', player)
        },

        _onYoutubeError( player )
        {
            // console.log('_onYoutubeError', player)
        },


        /*onPlayerReady()
        {
            if( this.autoplay )
            {
                this.play()
            }
        },

        onPlayerStateChange()
        {

            if( this.mute == true ){
                this.mute();
            }

            if( event.type == "ended" ||  event.data == 0 ){ // ended
                this.onPlayerEnded();
            }
            if( event.type == "play" || event.data == 1 ){ // play
                this.$el.classList.remove('is-loading');
                this.onPlayerPlay();
            }
            if( event.type == "pause" || event.data == 2 ){ // pause
                this.onPlayerPause();
            }
            if( event.type == "progress"){ //buffer
                //this.onPlayerBuffer();
            }
        },

        onPlayerError(event)
        {
            //console.warn('ERROR VIDEO:', event);
            //this.fire('error');
        },

        onTogglePlay()
        {
            this.paused ? this.play() : this.pause();
        },*/

        /*
                ┌─────────────────────────────────────────────
                │
                │       PLAY / PAUSE
                │
                └─────────────────────────────────────────────
        */

        play()
        {
            if(this._youtubePlayer)
            {
                this._youtubePlayer.playVideo()
            }
        },

        pause()
        {
            if(this._youtubePlayer)
            {
                this._youtubePlayer.pauseVideo()
            }
        },

        togglePlay()
        {
            if ( this.isPlaying )
            {
                this.pause()
            }
            else
            {
                this.play()
            }
        },

        _play()
        {
            this.isPlaying = true
            this._updateSeekBar()
            this.$emit('play', this)
        },

        _pause()
        {
            this.isPlaying = false
            this.$emit('pause', this)
        },






        /*
                ┌─────────────────────────────────────────────
                │
                │       TIME / SEEKBAR
                │
                └─────────────────────────────────────────────
        */

        getCurrentTime()
        {
            if(this._youtubePlayer)
            {
                return this._youtubePlayer.getCurrentTime()
            }
        },

        getTotalTime()
        {
            if(this._youtubePlayer)
            {
                return this._youtubePlayer.getDuration()
            }
        },

        // seconds
        seekTo( time, final = true )
        {
            if(this._youtubePlayer)
            {
                this._youtubePlayer.seekTo( time, final )
            }

            if (!final)
            {
                this.currentTimelineValue = time / this.getTotalTime()
            }
        },

        _updateSeekBar( force = false )
        {
            cancelAnimationFrame(this._updtSeekbarRAF)
            if ( this._timeUpdateEnable && (this.isPlaying || force) )
            {
                this.currentTimelineValue = this.getCurrentTime() / this.getTotalTime()
            }

            if (this.isPlaying)
            {
                this._updtSeekbarRAF = requestAnimationFrame( this._updateSeekBar.bind(this, false) )
            }
        },

        _startSeek( event )
        {
            this._timeUpdateEnable = false
            this._beforeSeekData = {
                playing: this.isPlaying
            }
            this.pause()
            this.seekTo( event.u * this.getTotalTime(), false )
        },

        _updateSeek( event )
        {
            this.seekTo( event.u * this.getTotalTime(), false )
        },

        _stopSeek( event )
        {
            this._timeUpdateEnable = true
            this.seekTo(event.u * this.getTotalTime(), true)
            if (this._beforeSeekData.playing)
            {
                this.play()
            }
        },


        /*isMuted()
        {
            if(this._youtubePlayer)
            {
                return this._youtubePlayer.isMuted()
            }
        },*/

        /*
                ┌─────────────────────────────────────────────
                │
                │       SOUND
                │
                └─────────────────────────────────────────────
        */

        mute()
        {
            if(this._youtubePlayer)
            {
                this._youtubePlayer.mute()
            }

            this.isMuted = true
            this.$emit('mute', this)
        },

        unMute()
        {
            if(this._youtubePlayer)
            {
                this._youtubePlayer.unMute()
            }

            this.isMuted = false
            this.$emit('unmute', this)
        },

        toggleMute()
        {
            if ( this.isMuted )
            {
                this.unMute()
            }
            else
            {
                this.mute()
            }
        },




        /*
                ┌─────────────────────────────────────────────
                │
                │       EVENTS
                │
                └─────────────────────────────────────────────
        */

        _complete()
        {
            this._pause()
            this.$emit('complete', this)
        }




        /*_onPlayingChange()
        {
            this.isPlaying ? this.onPlayerPlay() : this.onPlayerPause();
        },

        onPlayerPlay()
        {
            this.$el.classList.add('is-playing');
            this.$el.classList.remove('is-paused');

            this.paused = false;
            this.startProgress();

            if( this.controls ){
                this.toggleControls();
            }

            if( this.isFirstPlay ){
                this.$el.classList.add('is-started');
                this.isFirstPlay = false;
                this._duration = this.getDuration();
            }

            this.play();
        },

        onPlayerPause()
        {
            this.$el.classList.remove('is-playing');
            this.$el.classList.add('is-paused');
            this.paused = true;
            this.pause();
        },

        onPlayerEnded()
        {
            if(this.loop){
                this.onPlayerPlay();
            }
            else {
                this.onPlayerPause();
                this.$el.classList.remove('is-started');
                this.isFirstPlay = true;
            }

            this.currentTimelineValue = 0;
        },

        startProgress()
        {
            clearTimeout(this.progressTimer);
            this.updateTime();
        },

        stopProgress()
        {
            clearTimeout(this.progressTimer);
            this.progressTimer = null;
        },*/

        /*onSeek( event )
        {

            this.pause();
            this.$el.classList.add('is-seeking');
            this._winWidth = window.innerWidth;
            this._width = this.$el.offsetWidth;
            this._mouseX = event.clientX - (this._winWidth - this._width) * .5;

            this.currentTimelineValue = (this._mouseX / this._width);
// seekTo(t, false)
            console.log('onSeek', this.currentTimelineValue)

            setTimeout( () => {
                // this.$player.currentTime = this.currentTimelineValue * this._duration;
                // this.play();
            }, 100)

            clearTimeout(this._seekingTimer);
            this._seekingTimer = setTimeout( () => {
                // this.$el.classList.remove('is-seeking');
            }, 800)

        },*/
/*
        updateTime( e, time )
        {

            this._currentTime = this.getCurrentTime();

            this.progressTimer = setTimeout( () => {
                this.updateTime();
            }, 100);
        },

        update()
        {
            if(!this.isPlaying){
                return;
            }

            this._timelineValue = this._currentTime / this._duration;

            this.currentTimelineValue = this._timelineValue
            console.log(this.currentTimelineValue)
        },

        getCurrentTime()
        {
            return this.$player.currentTime;
        },

        getDuration()
        {
            return this.$player.duration;
        }*/

    }

}

export default mixin
